<template>
    <div>
        <div class="content-header text-center">
            <h2>Business Data Search</h2>
        </div>
        <p class="text-center">Dataset size affects map load time. The initial dataset is the US Households baseline with 10,000 records, please allow 10-15 seconds for the map to load or update, while using this default dataset. As long as no dataset is specified, the US Households baseline will be used.</p>

                    <form class="form-control p-2" id="mapsearch"  @submit.prevent="updateMapData">
                        <div class="container-fluid">
                            <div class="row align-items-center mb-2">
                                <div class="col">
                                    <div class="p-2">
                                        <div class="col mb-2">
                                            <div class="form-check mr-2">
                                                <input class="form-check-input" type="radio" v-model="regiontype" value="current">
                                                <label class="form-check-label">
                                                    Current Location
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col mb-2">
                                            <div class="form-check mr-2">
                                                <input class="form-check-input" type="radio" v-model="regiontype" value="state">
                                                <label class="form-check-label">
                                                    State
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col mb-2">
                                            <div class="form-check mr-4">
                                                <input class="form-check-input" type="radio" v-model="regiontype" value="zipcode">
                                                <label class="form-check-label">
                                                    Zipcode
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="regiontype === 'current'">
                                        <div class="form-group">
                                            <label>Current Location</label>
                                            <!-- p>Lat: {{this.currentlocation[0].lat}}</p>
                                            <p>Long: {{this.currentlocation[0].lng}}</p -->
                                        </div>
                                    </div>
                                    <div v-if="regiontype === 'zipcode'">
                                        <div class="form-group">
                                            <label>Enter Location (Zipcode)</label>
                                            <input v-model="locationselect" class="form-control input-lg" />
                                        </div>
                                    </div>
                                    <div v-if="regiontype === 'state'">
                                        <div class="form-group">
                                            <label>Select State</label>
                                            <select v-model="locationselect" class="form-select">
                                                <option value="">Make a selection</option>
                                                <option value="AK">AK</option>
                                                <option value="AL">AL</option>
                                                <option value="AR">AR</option>
                                                <option value="AS">AS</option>
                                                <option value="AZ">AZ</option>
                                                <option value="CA">CA</option>
                                                <option value="CO">CO</option>
                                                <option value="CT">CT</option>
                                                <option value="DC">DC</option>
                                                <option value="DE">DE</option>
                                                <option value="FL">FL</option>
                                                <option value="GA">GA</option>
                                                <option value="GU">GU</option>
                                                <option value="HI">HI</option>
                                                <option value="IA">IA</option>
                                                <option value="ID">ID</option>
                                                <option value="IL">IL</option>
                                                <option value="IN">IN</option>
                                                <option value="KS">KS</option>
                                                <option value="KY">KY</option>
                                                <option value="LA">LA</option>
                                                <option value="MA">MA</option>
                                                <option value="MD">MD</option>
                                                <option value="ME">ME</option>
                                                <option value="MI">MI</option>
                                                <option value="MN">MN</option>
                                                <option value="MO">MO</option>
                                                <option value="MP">MP</option>
                                                <option value="MS">MS</option>
                                                <option value="MT">MT</option>
                                                <option value="NC">NC</option>
                                                <option value="ND">ND</option>
                                                <option value="NE">NE</option>
                                                <option value="NH">NH</option>
                                                <option value="NJ">NJ</option>
                                                <option value="NM">NM</option>
                                                <option value="NV">NV</option>
                                                <option value="NY">NY</option>
                                                <option value="OH">OH</option>
                                                <option value="OK">OK</option>
                                                <option value="OR">OR</option>
                                                <option value="PA">PA</option>
                                                <option value="PR">PR</option>
                                                <option value="RI">RI</option>
                                                <option value="SC">SC</option>
                                                <option value="SD">SD</option>
                                                <option value="TN">TN</option>
                                                <option value="TX">TX</option>
                                                <option value="UM">UM</option>
                                                <option value="UT">UT</option>
                                                <option value="VA">VA</option>
                                                <option value="VI">VI</option>
                                                <option value="VT">VT</option>
                                                <option value="WA">WA</option>
                                                <option value="WI">WI</option>
                                                <option value="WV">WV</option>
                                                <option value="WY">WY</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col mb-2">
                                    <div class="form-check mr-2">
                                        <input class="form-check-input" type="radio" v-model="maptype" value="markers" @change="selectMapType('markers')">
                                        <label class="form-check-label">
                                            Marker Clusters
                                        </label>
                                    </div>
                                </div>
                                <div class="col mb-2">
                                    <button class="btn btn-outline-primary float-end" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFilters" aria-expanded="true" aria-controls="collapseFilters">
                                        Show/Hide Variables
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="collapse show" id="collapseFilters">
                            <div class="container">
                            
                            <div class="row align-items-center mb-2 h-100">
                                <div class="col text-center"><h3>Industry (SIC)</h3></div>
                            </div>
                            <div class="row align-items-center mb-2">
                                <vue3-simple-typeahead
                                    id="typeahead_id"
                                    placeholder="Start writing..."
                                    :items="compilednames"
                                    :minInputLength="1"
                                    :itemProjection="itemProjectionFunction"
                                    @selectItem="selectItemEventHandler"
                                    @onInput="onInputEventHandler"
                                    @onFocus="onFocusEventHandler"
                                    @onBlur="onBlurEventHandler"
                                    class="form-control input-lg"
                                >
                                </vue3-simple-typeahead>
                            </div>
                            <div class="row align-items-center mb-2 h-100">
                                <div class="col-md-4 mb-2 h-100 d-inline-block">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        A. Agriculture,<br>Forestry and Fishing
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_a">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}<!--  {{this.sic_a[index-1]['NAME']}} -->
                                            </label>
                                        </div>
                                    </ul>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-2 h-100 d-inline-block">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        B. Mining
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_b">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-2 h-100 d-inline-block">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        C. Construction
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_c">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-center mb-2 h-100">

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        D. Manufacturing
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_d">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        E. Transportation,<br>Communications, Electric, Gas,<br>and Sanitary Service
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_e">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        F. Wholesale Trade
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_f">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>

                            </div>
                            <div class="row align-items-center mb-2 h-100">

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        G. Retail Trade
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_g">
                                           <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        H. Finance, Insurance,<br>and Real Estate
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_h">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        I. Services
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_i">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row align-items-center mb-2 h-100">

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        J. Public Administration
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_j">
                                           <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>

                                <div class="col-md-4 mb-2 h-100">
                                    <div class="dropdown d-grid gap-2 h-100">
                                    <button class="btn btn-sm btn-link dropdown-toggle h-100" type="button" id="dropdownPurchases" data-bs-toggle="dropdown" aria-expanded="false">
                                        K. Non-Classifiable Establishments
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownPurchases">
                                        <div class="form-check" v-for="(data,index) in this.sic_k">
                                            <input class="form-check-input" type="checkbox" :value="data.SIC" :id="data.SIC" :name="data.SIC">
                                            <label class="form-check-label" :for="data.SIC">
                                                {{ data.NAME }}
                                            </label>
                                            </div>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row">

                            <div class="col-md-6 offset-md-3 mb-2">
                                    <div class="d-grid gap-2">
                                        <button class="btn btn-lg btn-info">Filter Results</button>
                                        <!-- button class="btn btn-lg btn-primary" v-on:click="updateMapData()">Filter Results</button -->
                                    </div>
                                </div>
                        </div>
                        
                        </div>
                        </div>
                    </form>
                    <div class="container-fluid">
                        <div class="row"> 
                            <div class="col" v-if="percentChecker()">
                                <h3>{{calcPercent()}}% match all variables:</h3>
                            </div>
                        </div>
                        <div class="row" v-if="this.regiontype.length">
                            <h3>Location: {{this.locationselect}}</h3>
                        </div>
                        <div class="row">
                            <div class="col-md-6" v-for="(query, index) in thequeries">
                                <p class="lead"><strong>{{index+1}}.</strong> {{returnVarName(query)}}</p>
                            </div>
                        </div>
                    </div>
        <component 
            v-bind:is="mapcomponent"
            v-bind:locationselect="locationselect"
            v-bind:locations="locations"
            v-bind:heatmaplocations="heatmaplocations"
            v-bind:maptype="maptype"
            :key="componentKey"
        />
    </div>
</template>
<script>
import axios from "axios";
import MarketResearchMap from "./MarketResearchMap.vue";
import MarketResearchHeatmapVue from './MarketResearchHeatmap.vue';
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import JSONa from '../sic_codes_a.json';
import JSONb from '../sic_codes_b.json';
import JSONc from '../sic_codes_c.json';
import JSONd from '../sic_codes_d.json';
import JSONe from '../sic_codes_e.json';
import JSONf from '../sic_codes_f.json';
import JSONg from '../sic_codes_g.json';
import JSONh from '../sic_codes_h.json';
import JSONi from '../sic_codes_i.json';
import JSONj from '../sic_codes_j.json';
import JSONk from '../sic_codes_k.json';
export default {
  name: "Market Research Businesses",
  components: { MarketResearchMap, MarketResearchHeatmapVue, SimpleTypeahead },
  data() {
    return {
      mapcomponent: MarketResearchMap,
      locationselect: 'CA',
      componentKey: 0,
      maptype: 'markers',
      regiontype: 'current',
      currentlocation: [],
      completedataresponse: [],
      heatmaplocations: [],
      locations: [],
      thequeries: [],
      compilednames: [],
      totalcount: 0,
      queriedcount: 0,
      sic_a: JSONa,
      sic_b: JSONb,
      sic_c: JSONc,
      sic_d: JSONd,
      sic_e: JSONe,
      sic_f: JSONf,
      sic_g: JSONg,
      sic_h: JSONh,
      sic_i: JSONi,
      sic_j: JSONj,
      sic_k: JSONk
    }
  },
methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    selectMapType(value) {
        // console.log('passed value '+value);
        this.maptype = value;
        if(value === 'markers') {
            this.mapcomponent = MarketResearchMap;
        } else if(value === 'heatmap') {
            this.mapcomponent = MarketResearchHeatmapVue;
        }
    },
    calcPercent() {
        var finalpercent = this.queriedcount / this.totalcount * 100;
        return finalpercent.toFixed(2);
    },
    percentChecker() {
        if(this.queriedcount >= 1) {
            return true;
        } else {
            return false;
        }
    },
    compileNamesRec() {
        this.compilednames.push(this.sic_a);
        this.compilednames.push(this.sic_b);
        this.compilednames.push(this.sic_c);
        this.compilednames.push(this.sic_d);
        this.compilednames.push(this.sic_e);
        this.compilednames.push(this.sic_f);
        this.compilednames.push(this.sic_g);
        this.compilednames.push(this.sic_h);
        this.compilednames.push(this.sic_i);
        this.compilednames.push(this.sic_j);
        this.compilednames.push(this.sic_k);
        this.compilednames = this.compilednames.flat();
        const wantedField = ['NAME'];
        this.compilednames = this.compilednames.map(o => wantedField.map(k => o[k]));
        this.compilednames = this.compilednames.flat();
    },
    returnVarName(val) {
        var alloptions = [];
        alloptions.push(this.sic_a);
        alloptions.push(this.sic_b);
        alloptions.push(this.sic_c);
        alloptions.push(this.sic_d);
        alloptions.push(this.sic_e);
        alloptions.push(this.sic_f);
        alloptions.push(this.sic_g);
        alloptions.push(this.sic_h);
        alloptions.push(this.sic_i);
        alloptions.push(this.sic_j);
        alloptions.push(this.sic_k);
        alloptions = alloptions.flat();
        let obj = alloptions.find(o => o.SIC === val);
        return obj['NAME'];
    },
    returnVarSic(val) {
        var alloptions = [];
        alloptions.push(this.sic_a);
        alloptions.push(this.sic_b);
        alloptions.push(this.sic_c);
        alloptions.push(this.sic_d);
        alloptions.push(this.sic_e);
        alloptions.push(this.sic_f);
        alloptions.push(this.sic_g);
        alloptions.push(this.sic_h);
        alloptions.push(this.sic_i);
        alloptions.push(this.sic_j);
        alloptions.push(this.sic_k);
        alloptions = alloptions.flat();
        let obj = alloptions.find(o => o.NAME === val);
        return obj['SIC'];
    },
    trimBlankRecords(data) {
        var iH = [];
        var b = data;
            for(var j = 0; j < b.length; j++){
                if ("lat" in b[j]) {
                    iH.push(b[j]); 
                }                        
            }
        return iH;
    },
    queryLocations(thedata) {
        var endresult = [];
        for(var j = 0; j < thedata.length; j++){
            var currentrecord = false;
                if(this.regiontype === 'zipcode') {
                    var thezipcode = this.locationselect;
                    if(thedata[j]['ZIP'] === thezipcode) {
                        currentrecord = true;
                    }
                    
                };
                if(this.regiontype === 'state') {
                    var thestate = this.locationselect;
                    if(thedata[j]['ST'] === thestate) {
                        currentrecord = true;
                    }
                };
                if(this.regiontype === 'current') {
                    this.geoFindMe();
                }
            if(currentrecord === true) {
                endresult.push(thedata[j]);
            }
        };
        return endresult;
    },
    querySelection(thedata,thequery) {
        var endresult = [];
        this.queriedcount = 0;
        for(var j = 0; j < thedata.length; j++){
            var currentrecord = false;
            for (var i = 0; i < thequery.length; i++) {
                if(thedata[j][thequery[i]] === 'Y') {
                    currentrecord = true;
                } else {
                    currentrecord = false;
                }    
            }
            if(currentrecord === true) {
                endresult.push(thedata[j]);
                this.queriedcount++;
            }
        };
        return endresult;
    },
    queryDemographics(thedata) {
        var endresult = [];
        var agevar = this.ageselect.split("-");
        this.queriedcount = 0;
        for(var j = 0; j < thedata.length; j++){
            var currentrecord = true;
            if(this.ageselect && (thedata[j]['AGE'] >= agevar[0] && thedata[j]['AGE'] <= agevar[1])) {
                currentrecord = false;
            };
            if(this.incomeselect && thedata[j]['HH_INCOME'] !== this.incomeselect) {
                currentrecord = false;
            };
            if(this.ethnicity && thedata[j]['ETHNIC_GRP'] !== this.ethnicity) {
                currentrecord = false;
            };
            if(currentrecord === true) {
                endresult.push(thedata[j]);
                this.queriedcount++;
            }
        };
        return endresult;
    },
    geoFindMe() {
        if (navigator.geolocation) {
            var location_timeout = setTimeout("geolocFail()", 10000);

            navigator.geolocation.getCurrentPosition(function(position) {
                clearTimeout(location_timeout);

                var lat = position.coords.latitude;
                var lng = position.coords.longitude;

                // geocodeLatLng(lat, lng);
                console.log(lat, lng);
            }, function(error) {
                clearTimeout(location_timeout);
                console.log('Geolocation fail');
                //geolocFail();
            });
        } else {
            // Fallback for no geolocation
            console.log('Geolocation fail');
        }
    },
    csvJSON(csv) {
            var lines=csv.replace('\r', '').split("\n");
            var result = [];
            var headers=lines[0].split(",");
            for(var i=1;i<lines.length;i++){
                var obj = {};
                var currentline=lines[i].split(",");
                for(var j=0;j<headers.length;j++){
                    var curline = currentline[j];
                    var necurline = (curline ?? '"').replaceAll('"', '');
                    obj[headers[j]] = necurline;
                }
                result.push(obj);
            }
            return result;
        },
    buildLocations(incoming) {
        for(var j = 0; j < incoming.length; j++){
            for (var key in incoming[j]) {
                if(key === 'LATITUDE') {
                    if(incoming[j]['LATITUDE']) {
                        incoming[j]['lat'] = parseFloat(incoming[j]['LATITUDE']); 
                    }
                    delete incoming[j]['LATITUDE'];
                } else if(key === 'LONGITUDE') {
                    if(incoming[j]['LONGITUDE']) {
                        incoming[j]['lng'] = parseFloat(incoming[j]['LONGITUDE']); 
                    }
                    delete incoming[j]['LONGITUDE'];
                } else {
                    delete incoming[j][key]
                }
            };
        };
        return incoming;
    },
    buildHeatmap(incoming) {
        var outgoing = [];
        for(var j = 0; j < incoming.length; j++){
            outgoing.push({ location: incoming[j], weight: 3});
        };
        return outgoing;
    },
    updateMapData() {
        var typeaheadval = document.getElementById('typeahead_id').value;
        console.log('Typeahead select VAL: ' + typeaheadval);
        var typeaheadsic = this.returnVarSic(typeaheadval);
        console.log('Typeahead select SIC: ' + typeaheadsic);
        let myForm = document.getElementById('mapsearch'); 
        let formData = new FormData(myForm);
        this.thequeries = [];
        if(typeaheadsic) {
            //console.log('yes');
            this.thequeries.push(typeaheadsic);
        }
        for (var pair of formData.entries()) {
            //if(pair[0] != "dataset") {
                this.thequeries.push(pair[0]);
            //}
        }
        console.log('SIC codes selected: '+JSON.stringify(this.thequeries));
            axios({
                method : 'POST',
                url : '/business_sic_lookup',
                data: formData
            }).then(
                (response) => {
                    console.log('test return data '+ JSON.stringify(response.data));

                    // this.completedataresponse = this.csvJSON(response.data);
                    this.completedataresponse = response.data;
                    this.totalcount = this.completedataresponse.length;
                    var finalquery = [];
                    if(this.regiontype.length) {
                        //var filteredlocations = this.queryLocations(this.completedataresponse);
                    } else {
                        //var filteredlocations = this.completedataresponse;
                    }
                    if(this.thequeries.length) {
                        // finalquery = this.querySelection(filteredlocations,this.thequeries);
                    } else {
                        // finalquery = filteredlocations;
                    };
                    // var fixedloc = this.buildLocations(finalquery);
                    // this.locations = this.trimBlankRecords(fixedloc);
                    // this.heatmaplocations = this.buildHeatmap(this.locations);
                    // this.forceRerender();  
            })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });
    }
  },
  mounted() {
    //this.geoFindMe();
    //if(!this.selecteddb) {
        //this.updateMapData();
    //}
  },
  created() {
    this.compileNamesRec();
    this.$getLocation()
      .then((coordinates) => {
        console.log(coordinates);
        this.currentlocation.push(coordinates);
        console.log('lat: '+this.currentlocation[0].lat+' long: '+this.currentlocation[0].lng);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>